// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_4gw6pr7tb6tzg12bJf", // canny 
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/5kA8xp4Jg3xc6IM3cI", // canny

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "Canny Gen AI 🎨",
    HOME_PAGE_TITLE: "Home - Canny Gen AI 🎨",
    DASHBOARD_PAGE_TITLE: "Home - Canny Gen AI 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to Canny Gen AI 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate images using Canny line structure of images, choose your image file, enter a prompt and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "canny_gen_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/canny-gen-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;